import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogExcluirData {
  title?: string;
  itemName?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'app-dialog-excluir',
  templateUrl: './dialog-excluir.component.html',
  styleUrls: ['./dialog-excluir.component.scss']
})
export class DialogExcluirComponent {
  title = 'Excluir Produto';
  itemName = '';
  message = '';
  confirmText = 'Confirmar';
  cancelText = 'Voltar';

  constructor(
    private dialogRef: MatDialogRef<DialogExcluirComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogExcluirData
  ) {
    this.title = data?.title ?? this.title;
    this.itemName = data?.itemName ?? this.itemName;
    this.message = data?.message ?? this.message;
    this.confirmText = data?.confirmText ?? this.confirmText;
    this.cancelText = data?.cancelText ?? this.cancelText;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
